module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "chapter"
  }, [_c('div', {
    staticClass: "inner_page"
  }, [_c('p', {
    staticClass: "linespace"
  }), _vm._v(" "), _c('p', {
    staticClass: "linespace"
  }), _vm._v(" "), _c('p', {
    staticClass: "linespace"
  }), _vm._v(" "), _c('p', {
    staticClass: "linespace"
  }), _vm._v(" "), _c('p', {
    staticClass: "linespace"
  }), _vm._v(" "), _c('p', {
    staticClass: "linespace"
  }), _vm._v(" "), _c('p', {
    staticClass: "linespace"
  }), _vm._v(" "), _c('p', {
    staticClass: "linespace"
  }), _vm._v(" "), _c('p', {
    staticClass: "para"
  }, [_c('a', {
    attrs: {
      "id": "page_vii"
    }
  }), _c('em', [_vm._v("Do not be afraid. I am the First and the Last. I am the Living One; I was dead, and behold I am alive and forever! And I hold the keys of death and Hades. Write, therefore, what you have seen, what is now and what will take place later.")])]), _vm._v(" "), _c('p', {
    staticClass: "para"
  }), _vm._v(" "), _c('p', {
    staticClass: "para"
  }, [_vm._v("This particular installation of the series is for anyone who believes that there is more out there than meets the naked eye . . . for people who intuitively know that this struggle of human existence, which has gone on since the very beginning of time, is not just a battle of physical and mental survival, but also involves the spirit. May love, peace, joy, Light, abundance, and a sense of the everlasting always reside in your spirit. As long as you have hope, you cannot be defeated.")]), _vm._v(" "), _c('p', {
    staticClass: "para"
  }), _vm._v(" "), _c('p', {
    staticClass: "para"
  })])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-7d6dd37b","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/xhtml/dedication.vue
// module id = 72
// module chunks = 0